<template>
  <div class="h-full p-20px">
    <div class="flex flex-column h-full">
      <vxe-toolbar class-name="px-16px" :loading="loading">
        <template #buttons>
          <Select ref="subject" :datas="subjectList" keyName="id" titleName="fullName"
                  v-model="params.subjectId" @change="subjectChange" :deletable="false" style="margin-right:16px;">
            <template #show="{value}">
              {{ value.code }} {{ value.fullName }}
            </template>
            <template #item="{item}">
              {{ item.code }} {{ item.fullName }}
            </template>
          </Select>
          <DropdownCustom ref="stateParamsDropdown" button class="h-btn-primary" trigger="click">
            <div>{{ params.voucherDate.start }} 至 {{ params.voucherDate.end }}</div>
            <template #content>
              <Form style="padding: 10px" :labelWidth="90">
                <FormItem class="!pb-5px" label="银行科目">
                  <Select ref="subject" :datas="subjectList" keyName="id" titleName="fullName"
                          v-model="params.subjectId" @change="subjectChange" :deletable="false">
                    <template #show="{value}">
                      {{ value.code }} {{ value.fullName }}
                    </template>
                    <template #item="{item}">
                      {{ item.code }} {{ item.fullName }}
                    </template>
                  </Select>
                </FormItem>
                <FormItem class="!pb-5px" label="凭证日期">
                  <div class="flex items-center">
                    <DatePicker v-model="params.voucherDate.start" :clearable="false" :option="{end:params.voucherDate.end}"/>
                    <span class="mx-8px">至</span>
                    <DatePicker v-model="params.voucherDate.end" :clearable="false" :option="{start:params.voucherDate.start}"/>
                  </div>
                </FormItem>
                <FormItem class="!pb-5px" label="入账日志号">
                  <Input v-model="params.bankBillNo"/>
                </FormItem>
                <FormItem class="!pb-5px" label="退据号">
                  <Input v-model="params.refundNo"/>
                </FormItem>
                <FormItem class="!pb-5px" label="摘要">
                  <Input v-model="params.summary"/>
                </FormItem>
<!--                <FormItem class="!pb-10px" label="金额">-->
<!--                  <div class="flex items-center">-->
<!--                    <NumberInput v-model="params.minMoney"/>-->
<!--                    <span class="mx-8px">至</span>-->
<!--                    <NumberInput v-model="params.maxMoney"/>-->
<!--                  </div>-->
<!--                </FormItem>-->
                <FormItem class="!pb-10px" label="借方金额">
                  <div class="flex items-center">
                    <NumberInput v-model="params.minDebitAmount"/>
                    <span class="mx-8px">至</span>
                    <NumberInput v-model="params.maxDebitAmount"/>
                  </div>
                </FormItem>
                <FormItem class="!pb-10px" label="贷方金额">
                  <div class="flex items-center">
                    <NumberInput v-model="params.minCreditAmount"/>
                    <span class="mx-8px">至</span>
                    <NumberInput v-model="params.maxCreditAmount"/>
                  </div>
                </FormItem>
                <FormItem class="!pb-5px">
                  <Button color="primary" @click="reSearch();" :loading="loading">确定</Button>
                  <Button @click="this.$refs.stateParamsDropdown.hide()">取消</Button>
                  <Button @click="resetForm">重置</Button>
                </FormItem>
              </Form>
            </template>
          </DropdownCustom>
        </template>
        <template #tools>
<!--          <Checkbox v-model="showAll" class="mr-16px">显示全部</Checkbox>-->

<!--          <Button @click="importStatement">导入</Button>-->
<!--          <Button @click="exportStatement">导出</Button>-->
<!--          <DropdownMenu-->
<!--              button-->
<!--              trigger="hover"-->
<!--              @clickItem="batchClickItem"-->
<!--              :datas="{batchDelete:'批量删除'}">-->
<!--            批量操作-->
<!--          </DropdownMenu>-->
        </template>
      </vxe-toolbar>
      <div class="flex-1 h-0px">

        <vxe-table height="auto"
                   border
                   ref="voucherStatementTable"
                   :loading="loading"
                   :row-config="{isCurrent: true, isHover: true}"
                   :scroll-y="{enabled: true}"
                   :checkbox-config="{trigger: 'row', highlight: true, range: true}"
                   :data="datas">
          <vxe-column type="checkbox" width="55" align="center"></vxe-column>
          <vxe-column title="对账" width="100" align="center">
            <template #default="{ row }">
              <vxe-icon name="check" v-if="row.hasOwnProperty('reconciliationId') && row.reconciliationId!=null"></vxe-icon>
            </template>
          </vxe-column>
<!--          <vxe-column title="对账ID" v-if="showAll" field="reconciliationId" width="150"/>-->
          <vxe-column title="凭证日期" field="voucherDate" width="120"/>
          <vxe-column title="借方金额" field="debitAmount" width="120" align="right">
            <template #default="{ row }">
              {{ numFormat(row.debitAmount) }}
            </template>
          </vxe-column>
          <vxe-column title="贷方金额" field="creditAmount" width="120" align="right">
            <template #default="{ row }">
              {{ numFormat(row.creditAmount) }}
            </template>
          </vxe-column>
          <vxe-column title="摘要" field="summary" width="320" align="center"/>
          <vxe-column v-if="currentAccountSets.intelligentReconciliation" title="案号" field="caseinfo" width="200" align="center"/>
          <vxe-column title="凭证字号" width="100" align="center">
            <template #default="{ row }">
              {{ row.word }}{{ row.code }}
            </template>
          </vxe-column>
          <vxe-column v-if="currentAccountSets.intelligentReconciliation" title="银行流水号" field="bankBillNo" width="220" align="center"/>
          <vxe-column v-if="currentAccountSets.intelligentReconciliation" title="单据主键" field="djId" width="220" align="center"/>

        </vxe-table>

      </div>
      <vxe-pager @page-change="currentPageChange"
                 v-model:current-page="pagination.page"
                 v-model:page-size="pagination.pageSize"
                 :total="pagination.total"
                 :layouts="['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'PageCount', 'Total']">
        <template #left>
          <vxe-button @click="loadList()" type="text" size="mini" icon="fa fa-refresh" :loading="loading"></vxe-button>
        </template>
      </vxe-pager>
    </div>
  </div>
</template>

<script>
import {ref, h, watch, reactive} from "vue";
import Qs from "qs";
import {mapActions, mapGetters, mapState} from 'vuex'
import {clone, pick} from "xe-utils";
import {layer} from "@layui/layer-vue";
import manba from "manba";
import voucher from "@api/voucher";
import BankStatement from "@api/BankStatement";
import {downloadBlob} from "download.js";
import {confirm, message} from "heyui.ext";
import StatementImport from "@/views/reconciliation/StatementImport";
import CashierJournal from "@api/CashierJournal";
import CashierJournalBatchUpdate from "@/views/cashier/CashierJournalBatchUpdate";
import setting from "@api/setting";

export default {
  name: "BankStatement",
  data() {
    return {
      datas: [],
      showAll: false,
      accountDate: null,
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      subjectName: "",
      subjectList: [],
      params: {
        subjectId: null,
        voucherDate: {start: null, end: null},
        bankBillNo: "",
        summary: "",
        refundNo: null,
        minDebitAmount: null,
        maxDebitAmount: null,
        minCreditAmount: null,
        maxCreditAmount: null
      },
      loading: false,
      checkAll: false,
      param: [{title: '打印全部', key: 'printAll'}, {title: '打印选中', key: 'printCheck'}]
    };
  },
  watch: {
    checkAll(nval) {
      let data = Array.from(this.datas);
      data.forEach(val => val._checked = nval);
      this.datas = data;
    },
    showAll(nval) {
      setTimeout(() => {
        this.$refs.bankStatementTable.refreshColumn();
      }, 200)
    }
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    date() {
      return manba(this.accountDate);
    }
  },
  methods: {
    ...mapActions(['init']),
    subjectChange(subject) {
      this.subjectName = subject.fullName;
      this.reSearch();
    },
    currentPageChange() {
      this.loadList();
    },
    trigger(key) {
      this[key].call(this);
    },
    downloadTrigger(key) {
      if (key === 'all') {
        voucher.download(this.params).then((data) => {
          downloadBlob(this.currentAccountSets.companyName + (manba().format('YYYYMMDDHHmmss')) + "凭证.xlsx", data);
        })
      } else {
        let checked = this.datas.filter(value => value._checked);
        if (checked.length) {
          voucher.download({id: checked.map(value => value.id)}).then((data) => {
            downloadBlob(this.currentAccountSets.companyName + (manba().format('YYYYMMDDHHmmss')) + "凭证.xlsx", data);
          })
        } else {
          this.$Message("未选择记录");
        }
      }
    },
    printAll() {
      let param = Qs.stringify({audit: this.params.audit, voucherDateStart: this.params.voucherDate.start, voucherDateEnd: this.params.voucherDate.end}, {indices: false});
      window.open(`/api/pdf/voucher?${param}`);
    },
    printCheck() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        let param = Qs.stringify({id: checked.map(value => value.id)}, {indices: false});
        window.open(`/api/pdf/voucher?${param}`);
      } else {
        this.$Message("未选择记录");
      }
    },
    loadBankSubjectList(){
      return setting.subject.bankList().then(({data}) => {
        this.subjectList = data;
        if(this.subjectList.length>0){
          this.params.subjectId = this.subjectList[0].id;
          this.subjectName = this.subjectList[0].fullName;
        }
      });
    },
    reSearch(){
      this.pagination = {
        page: 1,
        pageSize: 20,
        total: 0
      };  //初始化页码
      this.loadList();
    },
    loadList() {
      const loadId = layer.load(2);
      voucher.reconciliationList(this.pagination, this.params).then(({data}) => {
        this.datas = data.results || [];
        this.pagination = {
          page: data.page,
          pageSize: data.pageSize,
          total: data.total
        }
      }).finally(() => {
        layer.close(loadId);
        this.$refs.stateParamsDropdown.hide();
      })
    },
    remove(row) {
      this.$Confirm("确认删除?").then(() => {
        const loadId = layer.load(2);
        BankStatement.delete([pick(row, ['id', 'year', 'month'])]).then(({data}) => {
          if (data && data.length) {
            this.$Message("部分删除不成功，请检查所在账期是否已结账~")
          } else {
            this.$Message("删除成功~")
            this.init();
          }

          this.loadList();
        }).finally(() => layer.close(loadId))
      });
    },
    doTrash(row) {
      confirm({
        content: `确认删除此记录?`,
        onConfirm: () => {
          loading.value = true;
          BankStatement.delete(row.id).then(() => {
            loadList();
          }).finally(() => loading.value = false)
        }
      })
    },
    batchDelete() {
      let checked = this.datas.filter(value => value._checked && !value.auditMemberId);
      if (checked.length) {
        this.$Confirm("确认删除?").then(() => {
          const loadId = layer.load(2);
          BankStatement.delete(checked.map(val => pick(val, ['id', 'year', 'month']))).then(({data}) => {
            if (data && data.length) {
              this.$Message("部分删除不成功，请检查所在账期是否已结账~")
            } else {
              this.$Message("删除成功~")
            }
            this.init();
            this.loadList();
          }).finally(() => {
            layer.close(loadId);
          });
        });
      } else {
        message.warn("没有可删除凭证~");
      }
    },
    exportStatement(){
      window.open("/api/bank/statement/download/" + account.value.id + "?" + Qs.stringify(Object.assign(params, page.value)))
    },
    batchClickItem(type){
      let records = this.$refs.bankStatementTable.getCheckboxRecords().map(row => row.id);
      if (records.length) {
        switch (type) {
          case 'batchDelete':
            confirm({
              content: `确认删除这些记录?`,
              onConfirm: () => {
                this.loading = true;
                BankStatement.batchDelete(records).then(() => {
                  this.loadList();
                }).finally(() => this.loading = false)
              }
            })
            break
          case 'setIoType':
          case 'setAccountingCategory':
          case 'setProject':

        }
      } else {
        message("请选择需要操作的记录~")
      }
    },

    resetForm() {
      this.params = clone(this.cloneParams, true)
    }
  },
  created() {
    const currentAccountDate = manba(this.currentAccountSets.currentAccountDate);
    const startDate = ref(currentAccountDate.startOf(manba.MONTH).format());
    const endDate = ref(currentAccountDate.endOf(manba.MONTH).format());
    this.params.voucherDate.start = startDate;
    this.params.voucherDate.end = endDate;
    this.cloneParams = clone(this.params, true);
    this.loadBankSubjectList().then(() =>{
      this.loadList();
    })

  }
};
</script>